/** Words of the notification bell (English in Phase 1; kept here for Urdu later). */
export const copy = {
  button: (unread: number) =>
    unread === 0 ? 'Notifications' : `Notifications, ${unread} unread`,
  title: 'Notifications',
  markAll: 'Mark all read',
  markingAll: 'Marking…',
  emptyTitle: "You're all caught up",
  emptyBody: (isAdmin: boolean) =>
    isAdmin
      ? 'Proofs to check, new clients and members who go quiet show up here.'
      : 'New clients, messages and members who go quiet show up here.',
  loadError: "Couldn't load notifications.",
  retry: 'Try again',
  unread: 'Unread',
  more: (n: number) => `Showing the latest ${n}`,
  overflow: '99+',
} as const;
